/**
 * The owner's mask-coverage check (docs/higgsfield-generation-rules.md): after the automatic
 * magenta key, the print area should cover 0.30–0.47 of the image — the full-TPU-coverage band,
 * measured on packshots at about 93 % height. A3: the verdict is a note, never a refusal. A Fixed height scales the
 * band by the area it changes, (pct / 93)²; with No height restriction the product may take
 * any size, so the band is not applied (log only). Perspective and a separate floating
 * phone can also lower the panel's image share; an advisory does not prove bad geometry.
 */
export const COVERAGE_BAND = [0.3, 0.47] as const;
const CALIBRATED_HEIGHT_PCT = 93;

export function coverageFailure(coverage: number, heightPct: number | null): string | null {
  if (heightPct === null) return null;
  const scale = (heightPct / CALIBRATED_HEIGHT_PCT) ** 2;
  const [lo, hi] = COVERAGE_BAND.map((edge) => edge * scale);
  if (coverage >= lo && coverage <= hi) return null;
  return `coverage_check_failed: the print area covers ${Math.round(coverage * 100)}% of the image, ` +
    `outside ${Math.round(lo * 100)}–${Math.round(hi * 100)}% — review this view's framing and print boundary`;
}
